<template>
  <div class="tab-container">
    <ul role="tablist">
      <li role="presentation" v-for="(item, i) in navItems" :key="item.id">
        <button
          role="tab"
          :tabindex="active === i ? '1' : '-1'"
          @click="changeActive(i)"
          @keydown="changeTabWithKeys($event, i)"
          :id="`${item.id}-id`"
          :aria-selected="active === i"
        >
          {{ item.displayText }}
        </button>
      </li>
      <div class="line">
        <div class="active-indicator"></div>
      </div>
    </ul>
  </div>
</template>

<script>
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-parens */
/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable no-unused-expressions */
import theme from '../../../mixins/theme';

export default {
  mixins: [theme],
  data() {
    return {
      active: 0,
    };
  },
  props: {
    /**
     * populates the navigation bar
     */
    navItems: {
      type: Array,
      required: true,
    },

    /**
     * initializes the active item on the navigation bar
     */
    initialActive: {
      type: Number,
      default: 0,
    },

    /**
     * classname of the panels created on the page the navigation bar is used
     */
    panelClass: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.changeActive(this.initialActive);
  },

  methods: {
    /**
     * @desc handles changing the active tab
     */
    changeActive(active) {
      // setting the active data to give the text required styling
      this.active = active;
      const li = this.$el.querySelectorAll('li'); // all list items
      const indicator = this.$el.querySelector('.active-indicator'); // the line indicator element

      // position of the first element in the list.
      const elem1 = li[0].getBoundingClientRect();
      // position of the active element in the list
      const elem2 = li[active].getBoundingClientRect();

      // calculating the distance between the first element and last element in the list
      // To determine the position of the indicator
      const distance = elem2.x - elem1.x;

      indicator.style.transform = `translateX(${distance}px)`; // positioning indicator
      indicator.style.width = `${li[active].clientWidth}px`; // setting width of indicator to expand to element width


      /**
       * emits event to perfom change action on page
       */
      this.$emit('select-tab', this.navItems[active]);
    },

    /**
     * @desc handles keydown event to change tab
     */
    changeTabWithKeys(event, index) {
      const panels = document.querySelectorAll(`.${this.panelClass}`);
      // Work out which key the user is pressing and
      // Calculate the new tab's index where appropriate
      const dir =
        event.keyCode === 37
          ? this.active - 1
          : event.keyCode === 39
          ? this.active + 1
          : event.keyCode === 40
          ? 'down'
          : null;
      if (dir !== null) {
        event.preventDefault();
        // If the down key is pressed, move focus to the open panel,
        // otherwise switch to the adjacent tab
        dir === 'down'
          ? panels[index].focus()
          : dir < this.navItems.length && dir >= 0
          ? this.changeActive(dir)
          : 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HorizontalNav.scss';
</style>
